import styles from './CommunityShotNotReady.module.css';

export default function CommunityShotNotReady() {
  return (
    <div className={styles.CommunityShotNotReady}>
      <h3>Animation still exporting...</h3>
      <p>Check back in a few minutes.</p>
    </div>
  );
}
